import script from "./ButtonSecondary.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonSecondary.vue?vue&type=script&setup=true&lang=js"

import "./ButtonSecondary.vue?vue&type=style&index=0&id=582c32f1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aa\\Desktop\\Client-files\\BB\\BB_Web\\bb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-582c32f1"]])

export default __exports__